import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS, QUERY_KEYS } from '~shared/api/query-keys';

export interface UpdateTrialEnrollmentForm {
  enabled: boolean;
}

export const updateTrialEnrollmentAPI = async (
  classId: string,
  update: UpdateTrialEnrollmentForm,
) => {
  const resp = await baseAPI.patch<UpdateTrialEnrollmentForm>(
    `/enrollments/${classId}/trial-enrollment`,
    update,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  return resp.data;
};

export const useUpdateTrialEnrollmentMutation = () => {
  return useMutation({
    mutationFn: async ({
      classId,
      update,
    }: {
      classId: string;
      update: UpdateTrialEnrollmentForm;
    }) => updateTrialEnrollmentAPI(classId, update),
    onSuccess: (_, params) => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.CLASSES(),
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.CLASSES, params.classId],
      });
    },
  });
};
